/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DayCountConvention {
    ACTUAL_ACTUAL_ISDA = 'ACTUAL_ACTUAL_ISDA',
    THIRTY_360_ISDA = 'THIRTY_360_ISDA',
    THIRTY_365_ISDA = 'THIRTY_365_ISDA',
    ACTUAL_365_FIXED = 'ACTUAL_365_FIXED',
}
